module.exports = __webpack_public_path__ + "img/placeholder-chat.625244a.webp";